import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl } from '@/helpers/api';

export const useApplication = (coachActivityId) => {
  const urlStr = `${getApiUrl()}/mega/application/structure/${coachActivityId}`;

  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });
  return swr;
};
